import { required } from 'ngrx-forms/validation';
import {
  checkIfControlIsAlreadyPresentByPropertyKey,
  getControlDefinitionByPropertyKey
} from '../helpers';
import {
  CONTROL_METADATA_KEY,
  VALIDATOR_KEY
} from '../metadata-keys';
import {
  removeFromMetadata,
  addToMetadata
} from '@digitaix/helpers';

export function Required(validatorErrorTemplate: string = 'DX.FORMS.VALIDATION.ERRORS.REQUIRED') {
  return function(target: any, propertyKey: string) {
    if (
      !checkIfControlIsAlreadyPresentByPropertyKey(
        target,
        propertyKey
      )
    ) {
      throw new Error(
        `[Required::${propertyKey}] Control definition for '${propertyKey}' is not set`
      );
    }
    const controlMetadata = getControlDefinitionByPropertyKey(
      target,
      propertyKey
    );
    removeFromMetadata(
      CONTROL_METADATA_KEY,
      { name: controlMetadata.name },
      target,
      undefined,
      (a, b) => a.name === b.name
    );
    addToMetadata(
      CONTROL_METADATA_KEY,
      { ...controlMetadata, required: true },
      target
    );
    addToMetadata(
      VALIDATOR_KEY,
      {
        controlId: controlMetadata.name,
        propertyKey,
        validator: required,
        validatorErrorTemplate
      },
      target
    );
  };
}
